import type { ModuleId } from './types';

/** Modules that put a product on screen. Portfolio-wide scenes need at least one of them. */
export const PRODUCT_MODULES: ModuleId[] = ['mint', 'research-space', 'native', 'carbonmove', 'climateviewpoint', 'etrust'];
